export const isReferralsEnabled = (store: Record<string,any> | any) : any => {
    return String(store?.storeReferrals?.allowCustRefs) === "1";
}